import { defineComponent } from 'vue';
import Icon from '@common/layout/Icon.vue';
import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
import { translator } from '~/zf/frontend/common/mixins';
export default defineComponent({
    name: 'Badge',
    compatConfig: {
        MODE: 3,
    },
    components: {
        Icon,
    },
    mixins: [translator],
    props: {
        text: {
            type: String,
            required: true,
        },
        color: {
            type: String,
        },
        pill: {
            type: Boolean,
            default: false,
        },
        canBeDeleted: {
            type: Boolean,
            default: false,
        },
        uncapitalize: {
            type: Boolean,
            default: false,
        },
        iconName: {
            type: String,
            default: null,
        },
        iconTitle: {
            type: String,
            default: '',
        },
    },
    emits: ['delete'],
    data() {
        return {
            BootstrapVariant,
        };
    },
});
